module.exports = __webpack_public_path__ + "media/old_images/icon-vertex-marker-b20560d0.png";